import { render, staticRenderFns } from "./AppTenantSwitch.vue?vue&type=template&id=685d54c6&scoped=true&"
import script from "./AppTenantSwitch.vue?vue&type=script&lang=js&"
export * from "./AppTenantSwitch.vue?vue&type=script&lang=js&"
import style0 from "./AppTenantSwitch.vue?vue&type=style&index=0&id=685d54c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685d54c6",
  null
  
)

export default component.exports